import { useCallback, useEffect, useState } from 'react';
// Custom hook.
// -----------------------------------------------------------------------------
export const useSessionStorage = (key, initialValue) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const [data, setData] = useState(() => {
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            const item = window.sessionStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        }
        catch (error) {
            return initialValue;
        }
    });
    useEffect(() => {
        try {
            const item = window.sessionStorage.getItem(key);
            setData(item ? JSON.parse(item) : initialValue);
        }
        catch (error) {
            setData(initialValue);
        }
    }, [initialValue, key]);
    // Helpers
    // ---------------------------------------------------------------------------
    const setValue = useCallback((value) => {
        try {
            const dataToStore = value instanceof Function ? value(data) : value;
            setData(dataToStore);
            if (typeof window !== 'undefined') {
                window.sessionStorage.setItem(key, JSON.stringify(dataToStore));
            }
        }
        catch (error) {
            console.log(error);
        }
    }, [data, key]);
    return [data, setValue];
};
//# sourceMappingURL=useSessionStorage.js.map